import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { Modal } from '@olxbr/ds-web'
import { SplitLoginPage } from '../SplitLoginPage/SplitLoginPage'
import styled from 'styled-components'
import { Container } from '@olxbr/design-system'
import useWindowSize from '../../../util/useWindowSize'
import { accountDomain } from '../../../settings/staticUrl'

const Content = styled(Container)``

const LoginModalComponent = styled(Modal)`
  .olx-modal__content {
    ${({ isMobile }) => !isMobile && `overflow-y: hidden`};
  }
`
const LoginModal = ({
  opened,
  onCloseCallback,
  onLoginSuccessCallback,
  onErrorCallBack,
  abTests,
}) => {
  const { isMobile } = useWindowSize()

  const onPhoneNotValidated = token => {
    navigateTo(`${accountDomain}/confirmacao-telefone?token=${token}&from=login`)
  }

  const onChallengePinCodeCall = challengeInfo => {
    const { token, send } = challengeInfo
    const redirectOptions = {
      PHONE: redirectToPhone2FA,
      EMAIL: redirectToEmail2FA,
    }
    redirectOptions[send.type](send.to, token)
  }

  const onRegisterClick = () => {
    navigateTo(`${accountDomain}/cadastro`)
  }

  // const onMagicLinkClick = () => {
  //   navigateTo(`${accountDomain}/enviar-email-acesso-sem-senha`)
  // }

  // const onMagicLinkEmailSentClick = () => {
  //   navigateTo(`${accountDomain}/acesso-sem-senha-email-enviado?email=${email}`)
  // }

  const onReactivationLinkClick = email => {
    const params = email ? `?email=${email}` : ''
    navigateTo(`${accountDomain}/reativacao-conta${params}`)
  }

  const onForgotPassword = () => {
    navigateTo(`${accountDomain}/recuperacao-senha`)
  }

  const redirectToPhone2FA = (phone, token) => {
    navigateTo(`${accountDomain}/desafio-telefone-pin-code?token=${token}&phone=${phone}`)
  }

  const redirectToEmail2FA = (email, token) => {
    navigateTo(`${accountDomain}/desafio-email-pin-code?token=${token}&email=${email}`)
  }

  const navigateTo = url => {
    window.location.href = url
  }

  const onLoginSuccess = () => {
    if (onLoginSuccessCallback) {
      onLoginSuccessCallback()
    }
  }

  const onError = () => {
    if (onErrorCallBack) {
      onErrorCallBack()
    }
  }

  const onClose = () => {
    if (onCloseCallback) {
      onCloseCallback()
    }
  }

  const redirectToVerifyYourAccess = (token, phone) => {
    if ((token, phone)) {
      const verifyYourAccessURL = new URL('https://confirme-sua-identidade.olx.com.br/')

      verifyYourAccessURL.searchParams.append('token', token)
      verifyYourAccessURL.searchParams.append('phone', phone)

      navigateTo(verifyYourAccessURL.toString())
    }
  }

  return (
    <LoginModalComponent
      id="modal-login"
      aria-label="modal-login"
      maxHeight={isMobile ? '500px' : '850px'}
      open={opened}
      closeCallback={onClose}
      preventCloseOnOutsideClick
      isMobile={isMobile}
    >
      <Content>
        {opened && (
          <SplitLoginPage
            modalMode
            // onCloseModal={onClose}
            onLoginSuccess={onLoginSuccess}
            onPhoneNotValidated={onPhoneNotValidated}
            onError={onError}
            onRegisterClick={onRegisterClick}
            onChallengePinCodeCall={onChallengePinCodeCall}
            // NeedHelp
            // onMagicLinkClick={onMagicLinkClick}
            // onMagicLinkEmailSentClick={onMagicLinkEmailSentClick}
            onReactivationLinkClick={onReactivationLinkClick}
            onForgotPassword={onForgotPassword}
            // showReactivationLink
            abTests={abTests}
            redirectToVerifyYourAccess={redirectToVerifyYourAccess}
          />
        )}
      </Content>
    </LoginModalComponent>
  )
}

LoginModal.propTypes = {
  opened: PropTypes.bool,
  onLoginSuccessCallback: PropTypes.func,
  onCloseModalCallback: PropTypes.func,
  onErrorCallBack: PropTypes.func,
  abTests: PropTypes.string,
  // onAccountNotValidated: PropTypes.func,
  // smartLockLogin: PropTypes.bool,
  // passwordlessSignIn: PropTypes.bool,
}

export { LoginModal }
